
define('text!presentation/messages/views/accessRevokedModal.html',[],function () { return '<div class="messages__access-revoked-action-modal">\n    <div class="action-modal__content">\n        <span class="action-modal__action-text"\n              data-bind="i18n: \'messages:phoneNumberNoLongerAvailable\'">\n        </span>\n    </div>\n</div>\n';});

